import React from "react"
import { AnimatePresence } from "framer-motion"
import { Container, Holder } from "./FadeDialog.style"

export default function FadeDialog({ show, children }) {
  return (
    <AnimatePresence>
      {show && (
        <Holder
          exit={{ opacity: 0 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            type: "spring",
            stiffness: 150,
            damping: 50,
            mass: 1.7,
            duration: 0.5
          }}
        >
          <Container>{children}</Container>
        </Holder>
      )}
    </AnimatePresence>
  )
}
